import GetDemoManage from './components/GetDemoManage';
import GetDemoHire from './components/GetDemoHire';

const GetDemoSection = ({ type }: { type?: 'manage' | 'hire' }) =>
  type === 'manage' ? <GetDemoManage /> : <GetDemoHire />;

export default GetDemoSection;
